import { render, staticRenderFns } from "./PersonCostEditDialog.vue?vue&type=template&id=fffd1016&"
import script from "./PersonCostEditDialog.vue?vue&type=script&lang=js&"
export * from "./PersonCostEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fffd1016')) {
      api.createRecord('fffd1016', component.options)
    } else {
      api.reload('fffd1016', component.options)
    }
    module.hot.accept("./PersonCostEditDialog.vue?vue&type=template&id=fffd1016&", function () {
      api.rerender('fffd1016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ProvisionData/components/PersonCostEditDialog.vue"
export default component.exports